/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanitySearchRequest = {
    filterBy?: HumanitySearchRequest.filterBy;
    term: string;
};

export namespace HumanitySearchRequest {

    export enum filterBy {
        ALL = 'ALL',
        BLOCK = 'BLOCK',
        TRANSACTION = 'TRANSACTION',
        ADDRESS = 'ADDRESS',
        BATCH_TRX = 'BATCH_TRX',
        TOKEN = 'TOKEN',
    }


}

